import * as dynamicFormActionTypes from "./actionTypes";

export function fetchFormLayoutData(data) {
    return {
        type: dynamicFormActionTypes.FETCH_FORM_LAYOUT_DATA,
        ...data,
    };
}

export function fetchFormLayoutDataSuccess(data) {
    return {
        type: dynamicFormActionTypes.FETCH_FORM_LAYOUT_DATA_SUCCESS,
        ...data,
    };
}

export function fetchFormLayoutDataFailure(error) {
    return {
        type: dynamicFormActionTypes.FETCH_FORM_LAYOUT_DATA_FAILURE,
        ...error,
    };
}

export function updateDraftForm(data) {
    return {
        type: dynamicFormActionTypes.UPDATE_DRAFT_FORM,
        ...data,
    };
}

export function updateBillingAddressStatus(data) {
    return {
        type: dynamicFormActionTypes.UPDATE_BILLING_ADDRESS_STATUS,
        ...data,
    };
}
export function updateDraftFormSuccess(data) {
    return {
        type: dynamicFormActionTypes.UPDATE_DRAFT_FORM_SUCCESS,
        ...data,
    };
}
export function updateWarrentyId(data) {
    return {
        type: dynamicFormActionTypes.UPDATE_WARRANTY_ID,
        ...data,
    };
}
export function mergeFormDatatoStore(data) {
    return {
        type: dynamicFormActionTypes.MERGE_FORM_DATA_TO_STORE,
        ...data,
    };
}
export function updateDraftFormFailure(error) {
    //need to check
    return {
        type: dynamicFormActionTypes.UPDATE_DRAFT_FORM_FAILURE,
        error,
    };
}
export function fetchSavedFormLayoutData(data) {
    return {
        type: dynamicFormActionTypes.FETCH_SAVED_FORM_LAYOUT_DATA,
        ...data,
    };
}
export function fetchSavedFormData(data) {
    return {
        type: dynamicFormActionTypes.FETCH_SAVED_FORM_DATA,
        ...data,
    };
}

export function fetchSavedFormDataAndCopy(data) {
    return {
        type: dynamicFormActionTypes.FETCH_SAVED_FORM_DATA_AND_COPY,
        ...data,
    };
}

export function fetchSavedFormLayoutDataSuccess(data) {
    return {
        type: dynamicFormActionTypes.FETCH_SAVED_FORM_LAYOUT_DATA_SUCCESS,
        ...data,
    };
}
export function fetchSavedFormDataSuccess(data) {
    return {
        type: dynamicFormActionTypes.FETCH_SAVED_FORM_DATA_SUCCESS,
        ...data,
    };
}

export function fetchSavedFormLayoutDataFailure(error) {
    return {
        type: dynamicFormActionTypes.FETCH_SAVED_FORM_LAYOUT_DATA_FAILURE,
        ...error,
    };
}
export function saveDraftForm(data) {
    return {
        type: dynamicFormActionTypes.SAVE_DRAFT_FORM,
        ...data,
    };
}
export function submitWarranty(data) {
    return {
        type: dynamicFormActionTypes.SUBMIT_WARRANTY,
        ...data,
    };
}

export function saveDraftFormSuccess(data) {
    return {
        type: dynamicFormActionTypes.SAVE_DRAFT_FORM_SUCCESS,
        ...data,
    };
}

export function saveDraftFormFailure(error) {
    return {
        type: dynamicFormActionTypes.SAVE_DRAFT_FORM_FAILURE,
        error,
    };
}

export function FormLayoutInitialState() {
    return {
        type: dynamicFormActionTypes.FORM_LAYOUT_INITIAL_STATE,
    };
}

export function removeFormLayoutData(data) {
    return {
        type: dynamicFormActionTypes.REMOVE_FORM_LAYOUT_DATA,
        ...data,
    };
}

export function modifyFormData(data) {
    return {
        type: dynamicFormActionTypes.MODIFY_FORM_DATA,
        ...data,
    };
}
export function getBuildAddressCountryCodeAsync(data) {
    return {
        type: dynamicFormActionTypes.GET_COUNTRY_CODE_BUILDINGADDR_ASYNC,
        ...data,
    };
}
export function getMailAddressCountryCodeAsync(data) {
    return {
        type: dynamicFormActionTypes.GET_COUNTRY_CODE_MAILADDRESS_ASYNC,
        ...data,
    };
}
export function getBuildingAddressCountryCode(data) {
    return {
        type: dynamicFormActionTypes.GET_BUILDING_ADDRESS_COUTRY_CODE,
        ...data,
    };
}
export function getMailAddressCountryCode(data) {
    return {
        type: dynamicFormActionTypes.GET_MAIL_ADDRESS_COUTRY_CODE,
        ...data,
    };
}
export function selectAddress(data) {
    return {
        type: dynamicFormActionTypes.SELECTED_ADDRESS,
        ...data,
    };
}
export function setSelectedAddressAsync(data) {
    return {
        type: dynamicFormActionTypes.SET_SELECTED_ADDRESS_ASYNC,
        ...data,
    };
}

/**
 * @function setReviewAndPayData
 * @param data
 * @description setReviewAndPayData
 * This function in action createor will be called from saga setReviewAndPayData function
 * which will intern call the reducer SET_REVIEW_AND_PAY_TO_REDUX_STORE use case.
 *  To store the data to store.
 * @ignore
 */
export function setReviewAndPayData(data) {
    return {
        type: dynamicFormActionTypes.SET_REVIEW_AND_PAY_TO_REDUX_STORE,
        ...data,
    };
}

/**
 * @param data
 * @description When the API is called from review and Pay index it calls here using
 *  saga getReviewAndPayData function as mediator.
 *  This will be called from the review and Pay widget to make API call and
 *  @ignore
 */
export function getReviewAndPayData(data) {
    return {
        type: dynamicFormActionTypes.FETCH_REVIEW_AND_PAY_FORM_DATA,
        ...data,
    };
}

export function updateNavigationMenuStatus(navStatue) {
    return {
        type: dynamicFormActionTypes.UPDATE_NAVIGATION_MENU_STATUS,
        payload: {
            navigable: navStatue,
            message: !navStatue ? "You cannot move to other tabs until building address is complete" : "",
        },
    };
}

export function clearNavigationMenuStatus() {
    return {
        type: dynamicFormActionTypes.CLEAR_NAVIGATION_MENU_STATUS,
    };
}

export function addFieldIdToStore(data) {
    return {
        type: dynamicFormActionTypes.ADD_FIELD_ID_TO_STORE,
        payload: data,
    };
}

export function removeFieldIdFromStore(id: string) {
    return {
        type: dynamicFormActionTypes.REMOVE_FIELD_ID_FROM_STORE,
        id,
    };
}
//
export function getErrorResponseOnNavChange(data) {
    return {
        type: dynamicFormActionTypes.FETCH_ERROR_RESPONSE,
        ...data,
    };
}
export function fetchFormErrorResponseSuccess(response) {
    return {
        type: dynamicFormActionTypes.FETCH_ERROR_RESPONSE_SUCCESS,
        response,
    };
}

/**
 * @function saveTemplate
 * @param data
 * @description This is to save the template for which the user has entered the name.
                It calls action creator saveTemplate with payload.
                then calls the save method in saga using  SAVE_TEMPLATE key
 * @ignore
 */
export function saveTemplate(data) {
    return {
        type: dynamicFormActionTypes.SAVE_TEMPLATE,
        ...data,
    };
}
/**
 * @function setTemplate
 * @param data
 * @description This is to save the template for which the user has entered the name.
                It calls action creator saveTemplate with payload.
                then calls the save method in saga using  SET_TEMPLATE_DATA key and
                Updat the store
 * @ignore
 */
export function setTemplate(data) {
    return {
        type: dynamicFormActionTypes.SET_TEMPLATE_DATA,
        ...data,
    };
}
/**
 * @function getTemplates
 * @param data
 * @description This is to save the template for which the user has entered the name.
                It calls action creator saveTemplate with payload.
                then calls the save method in saga using  FETCH_SAVED_TEMPLATES key and
                Updat the store
 @ignore
 *
 */
export function getTemplates(data) {
    return {
        type: dynamicFormActionTypes.FETCH_SAVED_TEMPLATES,
        ...data,
    };
}

/**
 * @function getTemplatesById
 * @param data
 * @ignore
 */
export function getTemplatesById(data) {
    return {
        type: dynamicFormActionTypes.GET_TEMPLATE_BY_ID,
        ...data,
    };
}

/**
 * @function setTemplateList
 * @param data
 * @description This is to save the template for which the user has entered the name.
                It calls action creator saveTemplate with payload.
                then calls the save method in saga using  SET_TEMPLATE_LIST key and
                Updat the store

 * @ignore
 */
export function setTemplateList(data) {
    return {
        type: dynamicFormActionTypes.SET_TEMPLATE_LIST,
        ...data,
    };
}

/**
 * @function deleteTemplates
 * @param data
 * @description This is to delete a particular of list of templates
 * @ignore
 *
 */
export function deleteTemplates(data) {
    return {
        type: dynamicFormActionTypes.DELETE_AND_UPDATE_TEMPLATE,
        ...data,
    };
}
/**
 * @function deleteTemplates
 * @param data
 * @description This is to delete a particular of list of templates
 * @ignore
 */
export function validateBuildingAddress(data) {
    return {
        type: dynamicFormActionTypes.VALIDATE_BUILDING_ADDRESS,
        ...data,
    };
}
export function addNavMenusToStore(navMenus) {
    return {
        type: dynamicFormActionTypes.ADD_NAV_MENUS_TO_STORE,
        navMenus,
    };
}
/**
 * @function setProjectDetails
 * @param data
 * @description This is to update a particular of list of project details
 * @ignore
 */
export function setProjectDetails(data) {
    return {
        type: dynamicFormActionTypes.UPDATE_PROJECT_DETAILS,
        ...data,
    };
}
export function addTabDetailsToStore(keyArray) {
    return {
        type: dynamicFormActionTypes.ADD_TAB_DETAILS_TO_STORE,
        keyArray,
    };
}

export function updateMenuCounter(navMenus) {
    return {
        type: dynamicFormActionTypes.UPDATE_MENU_COUNTER,
        navMenus,
    };
}
export function updateFormType(status) {
    return {
        type: dynamicFormActionTypes.CHECK_FORM_TYPE,
        status,
    };
}
export function toggleTechSupportPopUp(status) {
    return {
        type: dynamicFormActionTypes.TOGGLE_TECH_SUPPORT_POPUP,
        status,
    };
}

export function checkEditable(params) {
    return {
        type: dynamicFormActionTypes.FETCH_EDITABLE_STATUS,
        params,
    };
}

export function checkfieldEditableSuccess(response) {
    return {
        type: dynamicFormActionTypes.FETCH_EDITABLE_STATUS_SUCCESS,
        response,
    };
}
export function autoSaveFormData() {
    return {
        type: dynamicFormActionTypes.AUTO_SAVE_FORM,
    };
}

export function apiRunningStatus(status) {
    return {
        type: dynamicFormActionTypes.API_RUNNING_STATUS,
        status,
    };
}
export function layoutapiRunningStatus(status) {
    return {
        type: dynamicFormActionTypes.LAYOUT_API_RUNNING_STATUS,
        status,
    };
}
export function submitClicked(status) {
    return {
        type: dynamicFormActionTypes.UPDATE_SUBMIT_CLICK_STATUS,
        status,
    };
}

export function navigationClickDetails(clicks) {
    return {
        type: dynamicFormActionTypes.CAPTURE_NAV_BUTTON_CLICK,
        clickDetails: clicks,
    };
}

export const GetContractorFormSettings = () => {
    return {
        type: dynamicFormActionTypes.GET_CONTRACTOR_FORM_SETTINGS,
    };
};

export const SetContractorFormSettings = (contractorFormData) => {
    return {
        type: dynamicFormActionTypes.SET_CONTRACTOR_FORM_SETTINGS,
        contractorFormData,
    };
};

export const getPropertyManagerList = () => {
    return {
        type: dynamicFormActionTypes.GET_PROPERTY_MANAGER_LIST,
    }
}

export const updatePropertyManagerList = (propertyManagerList) => {
    return {
        type: dynamicFormActionTypes.UPDATE_PROPERTY_MANAGER_LIST,
        propertyManagerList,
    }
}

export const saveWarrantyVariance = (payload, warrantyId) => {
    return {
        type: dynamicFormActionTypes.SAVE_WARRANTY_VARIANCE,
        payload,
        warrantyId
    }
    
}

export const saveWarrantyVarianceSuccess = (data) => {
    return {
        type: dynamicFormActionTypes.SAVE_WARRANTY_VARIANCE_SUCCESS,
        data,
    }
}

export const saveWarrantyVarianceFailure = (error) => {
    return {
        type: dynamicFormActionTypes.SAVE_WARRANTY_VARIANCE_FAILURE,
        error,
    }
}

export const clearWarrantyVarianceData = () => {
    return {
        type: dynamicFormActionTypes.CLEAR_WARRANTY_VARIANCE_DATA,
    }
}